import { Component, inject } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { EventsStoreService } from 'src/app/services/stores/events.store.service';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss'],
  standalone: false,
})
export class EventsComponent {
  protected eventsStoreService = inject(EventsStoreService);
  protected auth: AuthService = inject(AuthService);
  displayedColumns: string[] = [
    'event',
    'clientName',
    'schedule',
    'location',
    'actions',
  ];
}
